export { default } from 'ember-collapsible-panel/components/cp-panel-toggle/component';
